import React from "react";

export default function StageHeader({ stageIndex, stage }) {
  return (
    <>
      <h2>
        <small>Stage {stageIndex + 1}: </small>
        {stage.title}
      </h2>
      <p>{stage.description}</p>
    </>
  );
}
